import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLT } from "./sections";

const inputCls = "h-11 w-full rounded-lg border border-white/15 bg-black/30 px-3 text-sm text-white outline-none placeholder:text-white/30 focus:border-[#00C462]";

export default function ContactDialog({ open, onOpenChange }) {
  const t = useLT();
  const [form, setForm] = useState({ name: "", email: "", company: "", phone: "", message: "" });
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setState("busy");
    setError("");
    try {
      await api.post("/public/contact", { ...form, plan: "business" });
      setState("sent");
    } catch (err) {
      setError(err?.response?.data?.detail || t("cError"));
      setState("idle");
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="contact-dialog" className="border-white/10 bg-[#061A0F] text-white sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-extrabold">{t("contactTitle")}</DialogTitle>
          <DialogDescription className="text-white/60">{t("contactText")}</DialogDescription>
        </DialogHeader>
        {state === "sent" ? (
          <div data-testid="contact-success" className="flex items-center gap-3 rounded-xl border border-[#00C462]/30 bg-[#00C462]/10 p-4 text-sm text-[#7EF0B4]">
            <CheckCircle2 className="h-5 w-5 shrink-0" />{t("cSent")}
          </div>
        ) : (
          <form onSubmit={submit} data-testid="contact-form" className="space-y-3">
            <input data-testid="contact-name-input" required minLength={2} placeholder={t("cName")} value={form.name} onChange={set("name")} className={inputCls} />
            <input data-testid="contact-email-input" required type="email" placeholder={t("cEmail")} value={form.email} onChange={set("email")} className={inputCls} />
            <div className="grid grid-cols-2 gap-3">
              <input data-testid="contact-company-input" placeholder={t("cCompany")} value={form.company} onChange={set("company")} className={inputCls} />
              <input data-testid="contact-phone-input" placeholder={t("cPhone")} value={form.phone} onChange={set("phone")} className={inputCls} />
            </div>
            <textarea data-testid="contact-message-input" required minLength={10} rows={4} placeholder={t("cMessage")} value={form.message} onChange={set("message")} className={`${inputCls} h-auto py-2.5`} />
            {error && <p data-testid="contact-error" className="text-sm text-[#FF7B8A]">{error}</p>}
            <button data-testid="contact-submit-btn" disabled={state === "busy"} className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-full bg-[#D4AF37] text-sm font-bold text-[#1A1400] transition-colors hover:bg-[#E5C456] disabled:opacity-60">
              {state === "busy" && <Loader2 className="h-4 w-4 animate-spin" />}{state === "busy" ? t("cSending") : t("cSend")}
            </button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
